import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import {CalculatorIcon} from 'lucide-react'
import {useCalculator} from '@/contexts/CalculatorContext'

export function PercentageTable() {
    const { 
        margin,
        currentPeriod,
        getAllPeriods,
        getNastupyPercentage,
        getMarginPercentage
    } = useCalculator()
    
    const periodData = getAllPeriods()
    const previousPeriod = currentPeriod > 0 ? periodData[currentPeriod - 1] : null
    const previousIsKpiMet = previousPeriod ? previousPeriod.isKpiMet : false
    const previousBonus = previousPeriod ? previousIsKpiMet ? getNastupyPercentage(previousPeriod.nastupy) : 0 : 0
    const currentMarginPercentage = getMarginPercentage(margin)
    const currentPercentageFormatted = currentMarginPercentage.toFixed(1) + '%'

    return (
        <Card className="w-full">
            <CardHeader>
                <div className="flex items-center gap-2">
                    <CalculatorIcon className="w-5 h-5 text-primary"/>
                    <div>
                        <CardTitle>1. složka</CardTitle>
                        <p className="text-sm text-muted-foreground mt-1">
                            Maržový bonus - vypočten per nástup<br/>
                            Vyplácen každé 3 měsíce
                        </p>
                    </div>
                </div>
            </CardHeader>
            <CardContent className="space-y-4">
                {previousPeriod && (
                    <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">
                        <div className="flex justify-between items-center">
                            <span className="text-sm text-blue-700">Bonus z předchozího období</span>
                            <span className="text-lg font-bold text-blue-700">+{previousBonus}%</span>
                        </div>
                        <p className="text-xs text-blue-600 mt-1">
                            Dosaženo díky {previousPeriod.nastupy} nástupům a {previousPeriod.contracts} NAS
                        </p>
                    </div>
                )}
                <div className="space-y-2">
                    {[
                        {range: '0 - 1999', percentage: '3.0%'},
                        {range: '2000 - 2500', percentage: '4.0%'},
                        {range: '2501 - 2999', percentage: '5.0%'},
                        {range: '3000 - 3500', percentage: '6.0%'},
                        {range: '3501 a více', percentage: '7.0%'},
                    ].map((item, index) => (
                        <div
                            key={index}
                            className={`flex justify-between py-2 border-b last:border-0 ${
                                item.percentage === currentPercentageFormatted 
                                    ? 'bg-green-50 px-2 rounded-md font-medium' 
                                    : ''
                            }`}
                        >
                            <span className={`${
                                item.percentage === currentPercentageFormatted 
                                    ? 'text-green-700' 
                                    : 'text-muted-foreground'
                            }`}>
                                {item.range}
                            </span>
                            <span className={`${
                                item.percentage === currentPercentageFormatted 
                                    ? 'text-green-700' 
                                    : 'font-medium'
                            }`}>
                                {item.percentage}
                            </span>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    )
} 